import { type SchedulerProFeaturesConfigType } from '@bryntum/schedulerpro'
import { template } from './template'
import { listeners } from './listeners'

export const eventTooltip: SchedulerProFeaturesConfigType['eventTooltip'] = {
  listeners,
  template,
}
